module.exports = __webpack_public_path__ + "static/img/197_TO8_2098_og.fd5941f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/197_TO8_2098_og.jpg
// module id = DsMG
// module chunks = 0